export default "__VITE_ASSET__DDvm21An__"